export enum ShareTargetTypeEnum {
  LOCATION = "LOCATION",
  DELIVERY = "DELIVERY",
}
